module.exports = __webpack_public_path__ + "img/send.90f3b356.svg";